module.exports = __webpack_public_path__ + "static/media/whole.da8d8085.mp4";